module.exports = __webpack_public_path__ + "img/wordle-small.35c9ad97.svg";